import { render, staticRenderFns } from "./recepcao.vue?vue&type=template&id=48b5b174&scoped=true"
import script from "./recepcao.vue?vue&type=script&lang=js"
export * from "./recepcao.vue?vue&type=script&lang=js"
import style0 from "./recepcao.vue?vue&type=style&index=0&id=48b5b174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b5b174",
  null
  
)

export default component.exports